"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomSortInternalApi = void 0;
const ApiBase_1 = require("../Implementation/ApiBase");
class CustomSortInternalApi extends ApiBase_1.ApiBase {
    getCustomSortComparer(column) {
        var _a;
        return (_a = this.getCustomSortOptions().customSortComparers) === null || _a === void 0 ? void 0 : _a.find((csc) => this.adaptable.api.scopeApi.isColumnInScope(column, csc.scope));
    }
}
exports.CustomSortInternalApi = CustomSortInternalApi;
